<template>
  <el-dialog
    width="60%"
    custom-class="import-dialog"
    title="优惠券"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchCondition.keywords"
            placeholder="请输入输入券名"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          ref="brandTable"
          :highlight-current-row="radio"
          @current-change="handleCurrentChange"
          @selection-change="handleSelectionChange"
          :data="sendCouponsList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column v-if="!radio" type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="发放名称"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status !== 0"
                class="coupon-name pointer"
                @click="toDetail(scope.row)"
                >{{ scope.row.name }}</span
              >
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sendWayTypeFormat"
            label="发放类型"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="状态"
            prop="statusFormat"
          >
            <!-- <template slot-scope="scope">
              {{ activeTab === 2 ? "已作废" : scope.row.statusFormat }}
            </template> -->
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="sendCouponsListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="saveGoods"
          >确 定</el-button
        >
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      checkedCurrentRow: {},
      batchCondition: {
        oldWord: "",
        newWord: "",
        wxshopCategoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {
        startDate: "",
        endDate: "",
        type: this.filterType
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false
    };
  },
  computed: mapState({
    sendCouponsListTotal: state => state.rules.sendCouponsListTotal,
    sendCouponsList: state => state.rules.sendCouponsList
  }),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    toDetail(v) {
      let routeData = this.$router.resolve({
        name: "SendDetail",
        query: {
          couponSendId: v.couponSendId,
          sendName: v.name,
          isSendToGuider: v.couponSendTarget === 2 || v.type === 2
        }
      });
      window.open(routeData.href, "_blank");
      //   this.$router.push({
      //     name: "SendDetail",
      //     query: {
      //       couponSendId: v.couponSendId,
      //       sendName: v.name,
      //       isSendToGuider: v.couponSendTarget === 2 || v.type === 2
      //     }
      //   });
    },
    saveGoods() {
      if (this.radio) {
        this.$emit("setLink", this.checkedCurrentRow);
      } else {
        this.$emit("saveGoods", this.checkedRow);
      }
    },
    handleSelectionChange(row) {
      this.checkedRow = row;
    },
    handleCurrentChange(row) {
      this.checkedCurrentRow = row;
    },
    close() {
      this.$emit("close");
    },
    submitRuleForm() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.wxshopCategoryId =
        batchCondition.wxshopCategoryId[
          batchCondition.wxshopCategoryId.length - 1
        ];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        status: "",
        sendWayType: 0,
        event: "luckyDraw"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startDate =
        this.searchCondition.ruleValidDate &&
        this.searchCondition.ruleValidDate.length > 0
          ? this.searchCondition.ruleValidDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.ruleValidDate &&
        this.searchCondition.ruleValidDate.length > 0
          ? this.searchCondition.ruleValidDate[1]
          : "";
      Object.assign(params, searchCondition);
      //   const actionName = queryAll
      //     ? "queryAllMicroShopGoodsList"
      //     : "queryMicroShopGoodsList";
      return this.$store.dispatch("querySendCoupons", params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
